export default __webpack_public_path__ + "static/BreeSerif-Regular-3efb03a61ca44dc7cf7071a9bf982a75.ttf";